export default __webpack_public_path__ + "media/VijayaScholarship.953ec4e5.jpg";